<template>
  <div data-testid="skeleton">
    <content-loader
      class="d-none d-md-block"
      :height="475"
      :width="825"
      :speed="2"
      primaryColor="#f3f3f3"
      secondaryColor="#dedede"
    >
      <rect x="435" y="65" rx="4" ry="4" width="200" height="25" />
      <rect x="435" y="115" rx="4" ry="4" width="320" height="12" />
      <rect x="435" y="140" rx="4" ry="4" width="320" height="12" />
      <rect x="435" y="165" rx="4" ry="4" width="150" height="12" />
      <rect x="0" y="65" rx="4" ry="4" width="400" height="225" />
      <rect x="0" y="325" rx="4" ry="4" width="825" height="70" />
    </content-loader>

    <content-loader
      class="d-md-none"
      :height="460"
      :width="540"
      :speed="2"
      primaryColor="#f3f3f3"
      secondaryColor="#dedede"
    >
      <rect x="0" y="20" rx="4" ry="4" width="300" height="30" />
      <rect x="0" y="70" rx="4" ry="4" width="540" height="250" />
      <rect x="0" y="350" rx="4" ry="4" width="540" height="20" />
      <rect x="0" y="390" rx="4" ry="4" width="540" height="20" />
      <rect x="0" y="430" rx="4" ry="4" width="320" height="20" />
    </content-loader>
  </div>
</template>

<script>
import { ContentLoader } from 'vue-content-loader'

export default {
  components: {
    ContentLoader
  }
}
</script>

<style></style>
